import { render } from "./DownloadsModule.vue?vue&type=template&id=bf588fe4"
import script from "./DownloadsModule.vue?vue&type=script&lang=js"
export * from "./DownloadsModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__